import React, { useState, useEffect } from 'react';

import Experience from './sections/experience/Experience';
import Projects from './sections/projects/Projects';
import About from './sections/about/About';
import Navigation from './components/styled/navigation/Navigation';
import BurgerNav from './components/styled/navigation/BurgerNav';

import ContactForm from './sections/contact/ContactForm';
import { SocialIcon } from 'react-social-icons';
import './styles/accessibility.css';

function App() {
  const [currentTheme, setCurrentActiveTheme] = useState('darkTheme');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', currentTheme === 'darkTheme' ? 'dark' : 'light');
  }, [currentTheme]);

  const toggleTheme = () => {
    setCurrentActiveTheme(prev => prev === 'darkTheme' ? 'lightTheme' : 'darkTheme');
  };

  return (
    <div>
      <a href="#main" id="skip-link">Skip to main content</a>
      <Navigation currentTheme={currentTheme} onToggleTheme={toggleTheme} />
      <BurgerNav />

      <main id="main" tabIndex="-1" className="min-h-screen outline-none">
        <section id="home" className="relative w-full">
          <div className="section-container section-container--main">
            <div className="max-w-[800px] bg-bg-body rounded-[8px] p-8">
              <h1 className="text-h1 m-0 mb-4 text-primary-main relative glitch-assemble" data-text="<pkaya/>">{`<pkaya/>`}</h1>
              <h2 className="text-h2 m-0 mb-4 text-primary-dark2 reveal reveal-delay-1">Software Development Engineer</h2>
              <p className="reveal reveal-delay-2">
                Software engineer with 8+ years of experience building web and mobile applications.
                Currently focused on developer experience, frontend architecture, and platform engineering
                at a high-growth SaaS platform serving 120,000+ weekly users. Active open-source contributor.
              </p>
              <div className="flex gap-4 mt-4 reveal reveal-delay-3">
                <a className="btn-theme" href="#exp">Experience</a>
                <a className="btn-theme" href="#projects">Projects</a>
              </div>
            </div>
          </div>
          <div className="absolute bg-primary-light3 bottom-0 left-0 min-w-full max-w-full h-[80%] -z-10"></div>
        </section>

        <section id="exp" className="w-full">
          <div className="section-container">
            <h2 className="text-h2 m-0 mb-4 text-primary-main">Work Experience</h2>
            <p>
              From startups to large SaaS platforms, I've worked across the full development lifecycle
              in cross-functional teams. Here's where I've been and what I've built.
            </p>
            <Experience />
          </div>
        </section>

        <section id="projects" className="w-full">
          <div className="section-container">
            <h2 className="text-h2 m-0 mb-4 text-primary-main">Projects</h2>
            <p>
              Very early in my degree I realised that I had a soft spot for web development. I love it because it's easy
              to quickly come up with something creative, useful and fun. Some personal projects I've worked on:
            </p>
            <Projects />
          </div>
        </section>

        <section id="about" className="w-full">
          <div className="section-container">
            <h2 className="text-h2 m-0 mb-4 text-primary-main">About Me</h2>
            <div>
              BSc Computer Science (1st Class Honours) from Plymouth University.
              I speak German (native), English (native-level), Turkish (fluent), and Swedish (intermediate).
              Active open-source contributor to n8n and Microsoft projects.
            </div>
            <About />
          </div>
        </section>

        <footer id="contact" className="mb-10">
          <div className="section-container flex flex-col items-center text-center">
            <h2 className="text-h2 m-0 mb-4 text-primary-main">Contact</h2>
            <p>Feel free to get in touch!</p>
            <ContactForm />
            <div className="flex gap-2 mt-6">
              <SocialIcon url="https://www.linkedin.com/in/pkaya89/" style={{ width: '40px', height: '40px' }} />
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
